import React, { useEffect, useState } from "react";
import "../CSS/Welcome.css";
import { Swiper, SwiperSlide } from 'swiper/react'; // Use React Swiper components
import { EffectCube, Autoplay } from 'swiper/modules'; // Import specific modules
import 'swiper/css'; // Core Swiper styles
import 'swiper/css/effect-cube'; // Cube effect styles
import Image1 from "../Images/internationalbadminton1.jpg";
import Image2 from "../Images/internationalbadminton2.jpg";
import Image3 from "../Images/internationalbadminton3.jpg";
import Image4 from "../Images/internationalbadminton4.jpg";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

const Welcome = () => {

    const navigate = useNavigate(); // Initialize navigate function

    const handleExploreClick = () => {
        navigate("/about"); // Navigate to /about
    };

    const [data,setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getHeroData");
            console.log('Fetched slide data:', response.data); 
            setData(response.data || {});
          } catch (error) {
            console.error('Error fetching data from backend:', error);
          }
        };
    
        fetchData();
      }, []);

    return (
        <div className="Welcome_Section">
            <div className="Welcome_AnimDev">
                <div className="content" style={{ textAlign: "justify" }}>
                    <h1>{data?.title || "Default Title"}</h1>
                    <p>
                        {data?.description || "Default Description"}
                    </p>
                    <button className="col-md-2 btn" onClick={handleExploreClick}>Explore</button>
                </div>
                <Swiper
                    effect="cube"
                    grabCursor={true}
                    loop={true}
                    speed={1000}
                    modules={[EffectCube, Autoplay]}
                    cubeEffect={{
                        shadow: true,
                        slideShadows: true,
                        shadowOffset: 20,
                        shadowScale: 0.94,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    className="swiper"
                >
                    <SwiperSlide>
                        <img src={Image4} alt="Slide 1" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={Image1} alt="Slide 2" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={Image2} alt="Slide 3" />
                    </SwiperSlide>
                    <SwiperSlide>
                        <img src={Image3} alt="Slide 4" />
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    );
};

export default Welcome;
